import React from 'react';
import Modal from '../Modal';
import ReactPlayer from 'react-player';
import BsInfoCircle from '@meronex/icons/bs/BsInfoCircle';
import { jsx as _jsx, Fragment as _Fragment } from "react/jsx-runtime";
var VideoModal = function VideoModal(_ref) {
  var isVisible = _ref.isVisible,
    setIsVisible = _ref.setIsVisible,
    videoUrl = _ref.videoUrl;
  return /*#__PURE__*/_jsx(_Fragment, {
    children: /*#__PURE__*/_jsx(Modal, {
      className: "w-[90vw] md:w-[55%] lg:w-[45%] md:h-[400px] lg:h-[400px]",
      visible: isVisible,
      onClick: function onClick() {
        return setIsVisible(false);
      },
      children: /*#__PURE__*/_jsx(ReactPlayer, {
        url: videoUrl,
        className: "react-player",
        light: false,
        playing: true,
        width: "100%",
        height: "100%",
        controls: true
      })
    })
  });
};
export default VideoModal;